import{a as i}from"./chunk-RAAYCPUM.js";function m(...n){return i(t,n)}var t=(n,u)=>n*u;export{m as a};
